export default __webpack_public_path__ + "static/media/id-check.a98088ca.svg";